import React from 'react';
import { Phone, Award, Clock } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = ({ onRegisterClick }) => {
  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-orange-50 -z-10"></div>
      <div className="absolute top-20 right-0 w-96 h-96 bg-blue-200/20 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-200/20 rounded-full blur-3xl -z-10"></div>

      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center px-4 py-2 bg-blue-100 rounded-full text-blue-700 text-sm font-medium">
              <Clock className="w-4 h-4 mr-2" />
              Pronto Intervento 24/7
            </div>
            
            <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 leading-tight">
              Idraulica e
              <span className="bg-gradient-to-r from-blue-600 to-orange-500 bg-clip-text text-transparent"> Ristrutturazioni </span>
              a Modena
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              Giovani professionisti con passione per i dettagli. Offriamo servizi di idraulica e ristrutturazione con precisione e impegno, senza tralasciare nulla.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:3514826210">
                <Button size="lg" className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6">
                  <Phone className="w-5 h-5 mr-2" />
                  Chiama Ora
                </Button>
              </a>
              <Button 
                size="lg" 
                onClick={onRegisterClick}
                className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white text-lg px-8 py-6"
              >
                <Award className="w-5 h-5 mr-2" />
                Registrati e Risparmia
              </Button>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center">
                <div className="flex text-orange-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
                <span className="ml-2 text-gray-700 font-semibold">5.0 su Google</span>
              </div>
              <div className="h-6 w-px bg-gray-300"></div>
              <div className="text-gray-700 font-semibold">500+ Interventi</div>
              <div className="h-6 w-px bg-gray-300"></div>
              <div className="text-gray-700 font-semibold">Modena & Provincia</div>
            </div>
          </div>

          {/* Image/Visual */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80" 
                alt="Lavori idraulici professionali"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/40 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="flex items-start gap-4">
                <div className="bg-orange-100 rounded-lg p-3">
                  <Award className="w-6 h-6 text-orange-600" />
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-lg">Sconto 10€ + Prima Uscita Gratis</p>
                  <p className="text-sm text-gray-600 mt-1">Registrati e risparmia 40€</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
